<template lang="pug">
.main-container
  div.margin-botton
    span.title Solicitações
  .header-container.margin-botton
    el-card
      .header-info-container
        .header-label-container
          .header-label Edital N°
          span {{this.edital.numero}}
        .header-label-container
          .header-label Data de abertura:
          span {{formatDate(this.edital.dataInicio)}}
        .header-label-container
          .header-label Data de encerramento:
          span {{formatDate(this.edital.dataFim)}}
        .header-label-container.click(@click="downloadEdital()")
          span Visualizar PDF do Edital
  .search-container.margin-botton
    el-card
      search-bar(
            :placeHolder="searchBarPlaceholder",
            :hasCleanButton="true",
            @search="(searchValue) => handleSearch(searchValue)"
          )
  .table-container
    el-card
      el-row(:gutter="20")
        el-col(:span="24")
            app-modal-edital(
              v-if="isModalVisible",
              :title= "editalVigente ? 'Editar edital' : 'Cadastrar edital'",
              :closeOutside="true",
              :hasFooter="true",
              :responsive="true",
              :editalVigente="editalVigente"
              @closeModal="isModalVisible = false",
              @finalizar="(edital) => {editalVigente = edital}"
            )
        el-col(:span="24")
          h2.custom-label Listagem de solicitações
        el-table.table(
          :data="listaSolicitacoes"
          :default-sort='{ prop: "edital.numero", order: "descending" }'
          @sort-change="sort"
          v-loading="loading"
        )
          template(slot="empty") Não foram encontradas solicitações com os dados informados
          el-table-column(
            label="Situação",
            header-align="center",
            align="center"
            sortable="custom"
            prop="situacao"
            width="100"
          )
            template(slot-scope="scope")
              el-tooltip(v-if="scope.row.situacao === 'AGUARDANDO_APROVACAO'" content="Aguardando análise")
                i(class="fas fa-circle yellowColor")
              el-tooltip(v-if="scope.row.situacao === 'RETIFICADO'" content="Retificação pendente")
                i(class="fas fa-exclamation")
              el-tooltip(v-if="scope.row.situacao === 'REJEITADO'" content="Solicitação reprovada")
                i(class="fas fa-times redColor")
              el-tooltip(v-if="scope.row.situacao === 'CREDENCIADO'" content="Solicitação aprovada")
                i(class="fas fa-check greenColor")
              el-tooltip(v-if="scope.row.situacao === 'AGUARDANDO_VALIDACAO'" content="Aguardando Validação")
                i(class="fas fa-solid fa-user-check")
          el-table-column(
            v-if="edital.tipoEdital === 'GEOMENSOR'"
            v-for="col in columnsGeomensor"
            :prop="col.key"
            :label="col.label"
            :key="col.prop"
            :sortable="col.order"
            :width="col.width"
          )
          el-table-column(
            v-if="edital.tipoEdital === 'VISTORIADOR'"
            v-for="col in columnsVistoriador"
            :prop="col.key"
            :label="col.label"
            :key="col.prop"
            :sortable="col.order"
            :width="col.width"
          )
          el-table-column(
            label="Ações",
            width="120",
            header-align="center",
            align="center"
          )
            template(slot-scope="scope")
              el-dropdown(trigger="click")
                  el-button(type="primary" size="mini") Ações
                    i.marginLeft(class="fas fa-chevron-down")
                  el-dropdown-menu(slot='dropdown')
                      el-dropdown-item(@click.native='validar(scope.row)' v-if="verifyValidar(scope.row)")
                          i.icone(class="fa fa-check")
                            span.textDropdown Analisar
                      el-dropdown-item(@click.native='abrirSolicitacao(scope.row)' v-if="!verifyValidar(scope.row)")
                          i.icone(class="fa fa-eye")
                            span.textDropdown Visualizar
                      el-dropdown-item(@click.native='abrirModalConversa(scope.row)')
                          i.icone(class="far fa-comments")
                            span.textDropdown Histórico de conversas
                      el-dropdown-item(@click.native='descredenciar(scope.row)' v-if="verifyDescredenciar(scope.row)")
                          i.icone(class="fa fa-ban")
                            span.textDropdown Descredenciar
                      el-dropdown-item(@click.native='validarCredenciadoModal(scope.row)' v-if="verifyValidarCredenciado(scope.row)")
                          i.icone(class="fa fa-check")
                            span.textDropdown Validar credenciado
      Pagination(:total="quantidadeResultados" :pagina="paginaAtual" :tamanhoPagina="tamanhoPagina" @changePage="changePage")
  el-row.margin-top.footer(type="flex", justify="start")
      el-button(
        @click="voltar"
        class="voltarButton"
      )
        i.fas.fa-chevron-left
        |  Voltar
      el-button(type="primary" @click='handleExport' :disabled='quantidadeResultados === 0')
        span.margin Exportar
        span.fa-download.fas

  modal-historico-conversa(
    v-if='showModalConversa'
    :modalOpen='showModalConversa'
    :solicitacao='solicitacao'
    @close-modal='showModalConversa = false'
  )

  modal-visualizar-solicitacao(
    v-if='showModalSolicitacao'
    :modalOpen='showModalSolicitacao'
    :solicitacao='solicitacaoVisualizar'
    @close-modal='showModalSolicitacao = false'
  )

</template>

<script>

import { SearchBar, Table, Pagination, AppNotificacao } from 'sicarf-components';
import { findSolcitacoesByFiltro, exportCSVListagemSolicitacoes, descredenciarSolicitacao, validarCredenciado } from '@/services/solicitacaoCredenciadoService';
import { getUsuario } from '@/store/auth';
import { getEditalById, downloadEditalById } from '@/services/editalService';
import situacoes from '@/constants/situacoes';
import AppModalEdital from '@/components/AppModalEdital';
import ModalHistoricoConversa from '@/components/modalHistoricoConversa';
import ModalVisualizarSolicitacao from '@/components/modalVisualizarEdital';
import { saveAs } from 'file-saver';

export default {
  components: {
    SearchBar,
    Table,
    Pagination,
    AppModalEdital,
    ModalHistoricoConversa,
    ModalVisualizarSolicitacao
  },
  mixins: [
    AppNotificacao
  ],
  data () {
    return {
      isModalVisible: false,
      showModalSolicitacao: false,
      edital: {},
      filtro: {},
      solicitacao: null,
      filtroSort: {},
      editalVigente: null,
      searchBarPlaceholder: 'Informe o nome ou CPF do interessado',
      listaSolicitacoes: [],
      quantidadeResultados: 0,
      paginaAtual: 0,
      tamanhoPagina: 15,
      loading: false,
      showModalConversa: false,
      columnsGeomensor: [
        {key: 'credenciado.pessoa.pessoaFisica.nome', label: 'Nome', order: 'custom', width: "320"},
        {key: 'credenciado.pessoa.pessoaFisica.cpf', label: 'CPF', width: ""},
        {key: 'credenciado.codigoIncra', label: 'Código do INCRA', width: ""},
        {key: 'credenciado.codigoCrea', label: 'Registro no conselho', width: ""},
        {key: 'credenciado.pessoa.email', label: 'E-mail', width: ""}
      ],
      columnsVistoriador: [
        {key: 'credenciado.pessoa.pessoaFisica.nome', label: 'Nome', order: 'custom', width: "320"},
        {key: 'credenciado.pessoa.pessoaFisica.cpf', label: 'CPF', width: ""},
        {key: 'credenciado.codigoCrea', label: 'Registro no conselho', width: ""},
        {key: 'credenciado.pessoa.email', label: 'E-mail', width: ""}
      ],
    }
  },
  async mounted () {
    this.loading = true;
    this.filtroSort.ordem = 'edital.numero';
    this.filtroSort.ordemDirecao = 'DESC';
    this.getDataEdital(this.$route.params.idEdital)
    this.handleSearch();
  },
  computed: {
    usuario () {
      return getUsuario()
    }
  },
  methods: {
    async handleSearch (searchValue, pagina = 0) {
      this.loading = true;
      this.filtro = {}
      this.filtro.campoSimples = searchValue || '';
      this.filtro.pagina = pagina;
      this.filtro.ordem = this.filtroSort.ordem;
      this.filtro.ordemDirecao = this.filtroSort.ordemDirecao;
      this.filtro.idEdital = this.$route.params.idEdital
      const resp = await findSolcitacoesByFiltro(this.filtro);
      this.listaSolicitacoes = resp.content;
      this.quantidadeResultados = resp.totalElements;
      this.loading = false;
    },
    descredenciar (row) {
      this.confirmBox('Após confirmar o solicitante sera descrendenciado, deseja continuar?', 'Descredenciar',
        () => {
          descredenciarSolicitacao(row)
            .then(() => {
              this.showNotificacao('SUCCESS', 'Sucesso', 'Descredenciado  com sucesso', '');
              this.handleSearch()
            })
            .catch(() => {
              this.showNotificacao('ERROR', 'Ops!', 'Erro ao Válidar Credenciado');
            })
        },
        () => { })
    },
    validarCredenciadoModal (row) {
      this.confirmBox(`Deseja validar o credenciado ${row.credenciado.pessoa.nomeRazaoSocial} ?`, 'Validação do Credenciado',
        () => {
          validarCredenciado(row)
            .then(() => {
              this.showNotificacao('SUCCESS', 'Sucesso', 'Válidado com sucesso');
              this.handleSearch()
            })
            .catch(() => {
              this.showNotificacao('ERROR', 'Ops!', 'Erro ao Validar');
            })
        },
        () => { })
    },
    changePage (newPage) {
      this.paginaAtual = newPage - 1;
      this.handleSearch(this.filtro.campoSimples, this.paginaAtual);
    },
    validar (solicitacao) {
      this.$router.push({
        name: 'solicitacoes/validar',
        params: {
          idSolicitacaoCredenciado: solicitacao.id,
          idEdital: this.$route.params.idEdital
        }
      });
    },
    abrirSolicitacao(s) {
      this.solicitacaoVisualizar = s;
      this.showModalSolicitacao = true;
    },
    abrirModalConversa (solicitacao) {
      this.showModalConversa = true
      this.solicitacao = solicitacao
    },
    voltar() {
      this.$router.push({
        name: 'listagem-editais/listagem',
      });
    },
    sort (item) {
      this.filtroSort.ordem = item.prop;
      if (item.order === 'ascending') {
        this.filtroSort.ordemDirecao = 'ASC';
      } else {
        this.filtroSort.ordemDirecao = 'DESC';
      }
      this.handleSearch(this.filtro.campoSimples, this.paginaAtual);
    },
    verifyValidar(solicitacao) {
      return solicitacao.situacao === situacoes.AGUARDANDO_APROVACAO
    },
    verifyDescredenciar(solicitacao) {
      return solicitacao.situacao === situacoes.AGUARDANDO_VALIDACAO && this.usuario?.perfilSelecionado?.codigo === 'CAGEO'
    },
    verifyValidarCredenciado(solicitacao) {
      return solicitacao.situacao === situacoes.AGUARDANDO_VALIDACAO
    },
    formatDate(time) {
      const date = new Date(time);
      const day = '0' + date.getDate();
      const month = '0' + (date.getMonth() + 1);
      const year = date.getFullYear();
      return `${day.substr(-2)}/${month.substr(-2)}/${year}`;
    },
    async getDataEdital(id) {
      const response = await getEditalById(id);
      this.edital = response;
    },
    async downloadEdital () {
      let urlBase = process.env.VUE_APP_ROOT_URL;
      window.open(urlBase + "/publico/edital/baixar?idEdital=" + this.filtro.idEdital, "_blank");
    },
    async downloadEdital_ () {
      const fileLink = document.createElement('a');
      const arquivo = await downloadEditalById(this.filtro.idEdital);
      if (arquivo) {
        const fileURL = new Blob([arquivo]);
        fileLink.setAttribute('download', 'edital' + "_" + this.edital.numero + '.pdf');
        fileLink.href = window.URL.createObjectURL(fileURL);
        document.body.appendChild(fileLink);
        fileLink.click();
      }
      return Promise.resolve();
    },
    async handleExport () {
      let tipoEdital = this.edital.tipoEdital.toLowerCase()
      const idEdital = this.$route.params.idEdital;
      const csv = await exportCSVListagemSolicitacoes(idEdital)
      saveAs(csv, `relatorio_listagem_solicitacoes_${tipoEdital}.csv`)
    }
  },
}
</script>

<style scoped lang="scss">
@import "@/assets/styles/_variables.scss";

.custom-label{
    font-size: $font-size-medium;
    text-align: left;
    color: #606266;
  }
.marginLeft {
  margin-left: 5px;
}
.cadastrar {
  float: right;
}
.marginRight {
  margin-right: 10px;
}
.groups-title {
  padding-left: 10px;
  text-align: start;
  display: flex;
}
.text-center {
  text-align: center;
}
.redColor {
  color: $error;
}
.greenColor {
  color: $color-primary;
}
.yellowColor {
  color: $warning;
}
.not-found-text {
  color: $font-color;
}
.textDropdown {
  margin-left: 5px;
}

.textDropdown[data-v-28d42c2c] {
  font-weight: 500;
}

.margin {
  margin-right: 10px;
}

.margin-botton {
  margin-bottom: 1.5rem;
}

.header-info-container {
  display: flex;
  justify-content: space-around;
  width: 100%;
  .header-label {
    font-weight: bold;
    margin-right: 5px;
  }
}

.header-label-container {
  display: flex;
  flex-direction: row;
}

.title {
  font-size: $font-size-big;
  color: $title-color;
}

.export-button-container {
  display: flex;
  justify-content: flex-end;

  .fas {
    margin-left: 10px;
  }
}

.click {
  color: $color-primary;
  cursor: pointer;
  font-weight: bold;

  :hover {
    color: $card-dashboard-green;
  }
}

.voltarButton:hover, .voltarButton:focus {
  color: #009f61;
  border-color: #009f61;
}

</style>
